import PillButton from "src/components/PillButton";
import IconClose from "src/icons/IconClose";
import { useInsideModal } from "src/modals";
import { ShareModalProps } from "src/modals/configs/GlobalModal";
import { paddingXXXL } from "src/styles/spacing";
import { useSafeArea } from "src/swsh-native";

const ShareModalCloseButton = ({
	closeVariant,
}: {
	closeVariant: ShareModalProps["closeVariant"];
}) => {
	const safeArea = useSafeArea();
	const { closeSelf } = useInsideModal();
	const topSpacing = safeArea.top + paddingXXXL;
	const rightSpacing = paddingXXXL;

	switch (closeVariant) {
		case "Close":
			return (
				<PillButton
					testID="ShareModalClose"
					containerStyle={{
						position: "absolute",
						top: topSpacing,
						right: rightSpacing,
					}}
					Icon={IconClose}
					onPress={closeSelf}
				/>
			);
		case "Skip":
			return (
				<PillButton
					testID="ShareModalSkip"
					containerStyle={{
						position: "absolute",
						top: topSpacing,
						right: rightSpacing,
					}}
					onPress={closeSelf}
					opaque
				>
					Skip
				</PillButton>
			);
	}
};
export default ShareModalCloseButton;
